module.exports = __webpack_public_path__ + "img/tzgg.d2a14c16.jpg";